/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Transcript_TitleInputs */



/**
* | output |
* | --- |
* | "Transcript" |
*
* @param {Meeting_Transcript_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_transcript_title = /** @type {((inputs?: Meeting_Transcript_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Transcript_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Transcript")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription")
	return /** @type {LocalizedString} */ ("Transcript")
});